








import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryUserActivityRecordList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import constant from '@/utils/constant'

@Component({
  components: {
    VQuery,
    VTable,
  },
})
export default class UserActivityRecordList extends Vue {
  private queryParam: any = {
    startRow: 1,
    limit: 10,
    createTimeDaterange: [],
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  private queryModels: Array<QueryModel> = [
    { title: '用户ID', param: 'userId' },
    { title: '用户名称', param: 'userName' },
    { title: '来源', param: 'wayType', type: 'select', selectData: constant.UserActivityWayType },
    { title: '创建时间', param: 'createTimeDaterange', type: 'daterange' },
  ]

  private queryOperation: Array<TableOperation> = []

  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '用户ID', param: 'userId', width: 100 },
    { title: '用户名称', param: 'userName', width: 120 },
    { title: '手机号', param: 'mobilePhone', width: 120 },
    { title: '来源编码', param: 'wayType', width: 90 },
    { title: '来源', param: 'wayTypeName', width: 120 },
    { title: '活跃变动', param: 'qty' },
    { title: '业务号', param: 'recordNo', width: 220, overflow: true },
    { title: '创建时间', width: 160, param: 'createTime', formatter: DateFormat },
    { title: '备注', param: 'note', overflow: true },
  ]

  public activated() {
    this.loadData()
  }

  public async created() {
    this.loadData()
  }

  public async loadData() {
    const param = this.getRequestParam()
    const result = await QueryUserActivityRecordList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  private getRequestParam() {
    const param: any = { ...this.queryParam }
    if (param.createTimeDaterange && param.createTimeDaterange.length > 0) {
      param.createTimes = DateFormat(param.createTimeDaterange[0]) + ',' + DateFormat(param.createTimeDaterange[1])
    }
    param.startRow = (this.tableCurrntPage - 1) * (param.limit || 12)
    return param
  }

  public search() {
    this.tableCurrntPage = 1
    this.loadData()
  }

  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
